import {NgModule} from '@angular/core';
import {SharedComponents, SharedPipes, SharedServices} from './index';
import {DragulaModule} from 'ng2-dragula';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DeepBlurDirective} from './directives/deep-blur/deep-blur.directive';
import {CalendarModule} from 'primeng/calendar';
import {TableModule} from 'primeng/table';
import {SharedModule as PNGShared} from 'primeng/api';
import {ClickOutsideModule} from 'ng-click-outside';
import {CalendarWrapperComponent} from './components/calendar-wrapper/calendar-wrapper.component';
import {TranslateModule} from '@ngx-translate/core';
import {UICustomizationDirective} from './directives/ui-customization/ui-customization.directive';
import {TemplateParserComponent} from './components/workflow-bar/template-parser/template-parser.component';
import {FormItemLabelComponent} from './components/form-item-label/form-item-label.component';
import {PermissionSchemaRestrictComponent} from './directives/permission-schema/permission-schema-restrict.component';
import {CoreModule} from '@ispm/core/core.module';
import {HorizontalMouseWheelDirective} from './directives/mouse-wheel/horizontal.mousewheel.directive';
import {IspmTooltipComponent} from '@ispm/shared/components/tooltip/tooltip.component';
import {TooltipDirective} from '@ispm/shared/directives/tooltips/tooltip.directive';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {PanelComponent} from '@ispm/layout/components/panel/panel.component';
import {BrandsModule} from '../brands/brands.module';
import {StoreModule} from '@ngrx/store';
import {summaryReducer} from './dynamic-form/components/summary-table/store/reducers/summary.reducer';
import {RichEditBoxComponent} from './components/rich-edit-box/rich-edit-box.component';
import {RichEditboxModule} from '@wuitk/angular/components/rich-editbox';
import {DlsSharedModule} from '../dls-shared.module';
import {HelpAndSupportComponent} from './components/help-and-support/help-and-support.component';
import {TreeModule} from 'primeng/tree';
import {ContextMenuModule} from 'primeng/contextmenu';

@NgModule({
  imports: [
    CoreModule,
    DragulaModule,
    FormsModule,
    PNGShared,
    TableModule,
    ClickOutsideModule,
    CalendarModule,
    TranslateModule,
    MatSelectModule,
    MatIconModule,
    ReactiveFormsModule,
    BrandsModule,
    RichEditboxModule,
    StoreModule.forFeature('pcoSummaryTable', summaryReducer),
    DlsSharedModule,
    TreeModule,
    ContextMenuModule
  ],
  declarations: [...SharedComponents, ...SharedPipes, PanelComponent,
    DeepBlurDirective, CalendarWrapperComponent, UICustomizationDirective,
    TemplateParserComponent, FormItemLabelComponent,
    HorizontalMouseWheelDirective, IspmTooltipComponent, TooltipDirective, RichEditBoxComponent, HelpAndSupportComponent],
  exports: [CommonModule, ...SharedComponents, ...SharedPipes, DeepBlurDirective, UICustomizationDirective,
    PermissionSchemaRestrictComponent, PanelComponent, HorizontalMouseWheelDirective, CalendarWrapperComponent,
    IspmTooltipComponent, TooltipDirective, BrandsModule, TranslateModule, DlsSharedModule, HelpAndSupportComponent
  ],
  providers: [...SharedServices]
 })
export class SharedModule {
 }
